import { render, staticRenderFns } from "./BusinessNameRegistrationTaskQueue.vue?vue&type=template&id=4eb3cf44&scoped=true&"
import script from "./BusinessNameRegistrationTaskQueue.vue?vue&type=script&lang=js&"
export * from "./BusinessNameRegistrationTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameRegistrationTaskQueue.vue?vue&type=style&index=0&id=4eb3cf44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3cf44",
  null
  
)

export default component.exports